import React from 'react';
import { Box } from '@amzn/awsui-components-core';

export enum ContentRequestView {
  List = 'List',
  Catalog = 'Catalog',
}

// @ts-expect-error TS7031 - strict migration
const ContentRequestViewSelector = ({ contentRequestView, setContentRequestView }) => {
  const selectedClassName = 'content-request-view-selected';
  const listViewClassName =
    contentRequestView === ContentRequestView.List
      ? selectedClassName
      : 'content-request-view-not-selected';
  const catalogViewClassName =
    contentRequestView === ContentRequestView.Catalog
      ? selectedClassName
      : 'content-request-view-not-selected';

  return (
    /* tslint:disable:jsx-no-lambda */
    <Box textAlign="right" padding={{ bottom: 'm' }}>
      <Box variant="strong">View: </Box>
      <span
        className={`${listViewClassName}`}
        onClick={() => setContentRequestView(ContentRequestView.List)}
      >
        {ContentRequestView.List}
      </span>
      {` | `}
      <span
        className={catalogViewClassName}
        onClick={() => setContentRequestView(ContentRequestView.Catalog)}
      >
        {ContentRequestView.Catalog}
      </span>
    </Box>
  );
};

export default ContentRequestViewSelector;
